var a = /* @__PURE__ */ ((r) => (r.TEXT = "text", r.EMAIL = "email", r.TEXTAREA = "textarea", r.SEARCH = "search", r))(a || {});
export {
  a as RocheUIInputType
};
